export const BOT_MESSAGES_LOADING = 'BOT_MESSAGES_LOADING';
export const BOT_MESSAGES_LOADED = 'BOT_MESSAGES_LOADED';
export const BOT_MESSAGES_ERROR = 'BOT_MESSAGES_ERROR';
export const BOT_MESSAGE_SCHEMA_LOADED = 'BOT_MESSAGE_SCHEMA_LOADED';
export const BOT_MESSAGE_DELETED = 'BOT_MESSAGE_DELETED';
export const RESET_POPUP_BOT_MESSAGE = 'RESET_POPUP_BOT_MESSAGE';
export const BOT_MESSAGE_DETAIL_LOADED = 'BOT_MESSAGE_DETAIL_LOADED';
export const BOT_MESSAGE_UPDATING = 'BOT_MESSAGE_UPDATING';
export const BOT_MESSAGE_UPDATED = 'BOT_MESSAGE_UPDATED';
export const BOT_MESSAGE_CREATED = 'BOT_MESSAGE_CREATED';
export const BOT_MESSAGE_UPDATION_ERROR = 'BOT_MESSAGE_UPDATION_ERROR';
export const UPDATE_MESSAGE_FORM_DATA = 'UPDATE_MESSAGE_FORM_DATA';



// WEBPACK FOOTER //
// ./src/data/redux/botmessage_details/actiontypes.js